import { Box, Popover, Portal, Text, VStack } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  FilterButton,
  FilterButtonAction,
  FilterButtonActiveOptions,
  FilterButtonLabel,
  FilterButtonMenu,
  FilterButtonMenuHeader,
  FilterMenuItem,
} from '@/components/filters/filter-button';

interface CreatorStatusFilterProps {
  value: string | null;
  onChange: (status: string | null) => void;
  initialValue?: string | null;
}

const statusOptions = [
  { value: 'enrolled', translationKey: 'filters.creatorStatus.enrolled' },
  { value: 'contacted', translationKey: 'filters.creatorStatus.contacted' },
  { value: 'not contacted', translationKey: 'filters.creatorStatus.notContacted' },
] as const;

export const CreatorStatusFilter: React.FC<CreatorStatusFilterProps> = ({
  value,
  onChange,
  initialValue = null,
}) => {
  const { t } = useTranslation();
  const [tempStatus, setTempStatus] = useState<string | null>(initialValue);

  useEffect(() => {
    setTempStatus(value);
  }, [value]);

  const handleApply = () => {
    onChange(tempStatus);
  };

  const handleClear = () => {
    setTempStatus(null);
    onChange(null);
  };

  const handleStatusSelect = (status: string) => {
    setTempStatus(status);
  };

  const isFilterActive = !!value;
  const selectedOption = statusOptions.find((option) => option.value === value);

  return (
    <FilterButton isFilterActive={isFilterActive} onClearFilter={handleClear}>
      <FilterButtonAction>
        <FilterButtonLabel>{t('common.status')}</FilterButtonLabel>
        {isFilterActive && (
          <FilterButtonActiveOptions>
            {selectedOption
              ? t(selectedOption.translationKey)
              : t('filters.creatorStatus.allStatus')}
          </FilterButtonActiveOptions>
        )}
      </FilterButtonAction>
      <Portal>
        <Popover.Positioner>
          <FilterButtonMenu onApply={handleApply} maxWidth="200px">
            <FilterButtonMenuHeader title={t('common.status')} onClearAll={handleClear} />
            <Box p={3}>
              <VStack gap={0.5} align="stretch">
                {statusOptions.map((option) => (
                  <FilterMenuItem
                    key={option.value}
                    onClick={() => handleStatusSelect(option.value)}
                    isSelected={tempStatus === option.value}
                  >
                    <Text fontSize="sm">{t(option.translationKey)}</Text>
                  </FilterMenuItem>
                ))}
              </VStack>
            </Box>
          </FilterButtonMenu>
        </Popover.Positioner>
      </Portal>
    </FilterButton>
  );
};
